import * as React from "react";

const Checkmark: React.FC = () => {
    return (
        <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M2.49992 5.3335L0.833252 7.00016L5.83325 12.0002L15.8333 2.00016L14.1666 0.333496L5.83325 8.66683L2.49992 5.3335Z" fill="currentColor"/>
        </svg>
    );
};

export default React.memo(Checkmark);

